import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IntegrationIconService {
  private readonly mappings: { [key: string]: string } = {
    'microsoft entra id': 'microsoftentra.png',
    'microsoft entra': 'microsoftentra.png',
    'entra id': 'microsoftentra.png',
    'azure active directory': 'microsoftentra.png',
    wazuh: 'wazuh.png',
    sentinelone: 'sentinelOne.png',
    'sentinel-one': 'sentinelOne.png',
    'sentinel one': 'sentinelOne.png',
    manageengine: 'manageEngine.png',
    'manage engine': 'manageEngine.png',
    'manageengine asset explorer': 'manageEngine.png',
    sonicwall: 'sonicWall.png',
    'sonic wall': 'sonicWall.png',
    'cisco duo': 'cisco-duo.png',
    duo: 'cisco-duo.png',
    'google cloud': 'google-cloud.png',
    gcp: 'google-cloud.png',
    'google cloud platform (gcp)': 'google-cloud.png',
    'google workspace': 'google-workspace.png',
    'asset panda': 'asset-panda.png',
    'asset panda llc': 'asset-panda.png',
    freshservice: 'freshservice.png',
    freshworks: 'freshworks.png',
    'quick heal': 'quickheal.png',
    quickheal: 'quickheal.png',
    'prisma cloud': 'prisma-cloud.png',
    'trend micro': 'trendmicro.png',
    trendmicro: 'trendmicro.png',
    sofis: 'sophos.png',
    sophos: 'sophos.png',
    spiceworks: 'spicework.png',
    spicework: 'spicework.png',
    acunetix: 'acunetix.png',
    asana: 'asana.png',
    aws: 'aws.png',
    'amazon web services (aws)': 'aws.png',
    bitdefender: 'bitdefender.png',
    'bitdefender antivirus plus': 'bitdefender.png',
    'mcafee total protection': 'mcafee.png',
    'norton antivirus': 'default.svg',
    'mcafee complete data protection': 'mcafee.png',
    bitlocker: 'microsoft.png',
    'mcafee endpoint security': 'mcafee.png',
    'trend micro apex one': 'trendmicro.png',
    'trend micro antivirus': 'trendmicro.png',
    'eset nod32 antivirus': 'default.svg',
    crowdstrike: 'crowdstrike.png',
    fortinet: 'fortinet.png',
    google: 'google.png',
    'google email configuration': 'google.png',
    grafana: 'grafana.png',
    invgate: 'invgate.png',
    'invgate asset': 'invgate.png',
    jira: 'jira.png',
    kaspersky: 'kaspersky.png',
    mcafee: 'mcafee.png',
    metasploit: 'metasploit.png',
    microsoft: 'microsoft.png',
    'microsoft azure': 'microsoft.png',
    'microsoft email configuration': 'microsoft.png',
    netskope: 'netskope.png',
    'snipe-it': 'snipeit.png',
    snipeit: 'snipeit.png',
    nmap: 'nmap.png',
    okta: 'okta.png',
    qualys: 'qualys.png',
    servicenow: 'servicenow.png',
    smtp: 'smtp.png',
    'company smtp configuration': 'smtp.png',
  };

  hasLocalMapping(option: any): boolean {
    const rawName = option?.platformName || option?.name;
    if (!rawName) {
      return false;
    }
    const name = rawName.toLowerCase().trim();

    if (this.mappings[name]) {
      return true;
    }

    const keywords = [
      'sentinelone',
      'sentinel one',
      'sentinel-one',
      'fortinet',
      'fortigate',
      'forticlient',
      'manageengine',
      'manage engine',
      'colortokens',
      'color tokens',
      'color-tokens',
      'sophos',
      'qualys',
      'acunetix',
      'microsoft',
      'google',
      'aws',
      'amazon web services',
      'quick heal',
      'quickheal',
      'kaspersky',
      'forti',
      'sumo logic',
      'sumologic',
      'zscaler',
      'zscalar',
      'crowdstrike',
      'palo alto',
      'paloalto',
      'digital guardian',
      'digitalguardian',
      'recorded future',
      'recordedfuture',
      'cloudflare',
      'cisco',
      'juniper',
      'forcepoint',
      'f5',
      'akamai',
      'barracuda',
      'pfsense',
      'plixer',
      'aruba',
      'airdefense',
      'splunk',
      'snyk',
      'sonarqube',
      'veracode',
      'checkmarx',
      'black duck',
      'blackduck',
      'carbon black',
      'carbonblack',
      'qradar',
      'arcsight',
      'logrhythm',
      'exabeam',
      'wiz',
      'illumio',
      '1password',
      'lastpass',
      'dashlane',
      'rsa',
      'archer',
      'velocloud',
      'prtg',
      'armis',
      'digicert',
      'entrust',
      'globalsign',
      'safenet',
      'luna',
      'haproxy',
      'nginx',
      'teamviewer',
      'anydesk',
      'zendesk',
      'solarwinds',
    ];

    return keywords.some((kw) => name.includes(kw));
  }

  getFallbackIconUrl(option: any): string {
    const rawName = option?.platformName || option?.name;
    if (!rawName) {
      return '/assets/media/integration/default.svg';
    }
    const name = rawName.toLowerCase().trim();

    if (this.mappings[name]) {
      return `/assets/media/integration/${this.mappings[name]}`;
    }

    // Try substring matches for common brand/platform families
    if (name.includes('cloudflare')) {
      return '/assets/media/integration/cloudflarezerotrust.png';
    }
    if (name.includes('forcepoint')) {
      return '/assets/media/integration/forcepoint.png';
    }
    if (name.includes('juniper')) {
      return '/assets/media/integration/junipernetworkssdwan.png';
    }
    if (name.includes('f5')) {
      return '/assets/media/integration/f5advancedwaf.png';
    }
    if (name.includes('akamai')) {
      return '/assets/media/integration/akamaizerotrust.png';
    }
    if (name.includes('barracuda')) {
      return '/assets/media/integration/barracudawebapplicationfirewall.png';
    }
    if (name.includes('pfsense')) {
      return '/assets/media/integration/pfsense.png';
    }
    if (name.includes('plixer')) {
      return '/assets/media/integration/plixerscrutinizer.png';
    }
    if (name.includes('aruba')) {
      return '/assets/media/integration/arubanetworkswirelessintrusionprotection.png';
    }
    if (name.includes('airdefense')) {
      return '/assets/media/integration/airdefense.png';
    }
    if (name.includes('cisco')) {
      if (name.includes('umbrella')) {
        return '/assets/media/integration/ciscoumbrella.png';
      }
      if (name.includes('duo')) {
        return '/assets/media/integration/cisco-duo.png';
      }
      if (name.includes('netflow')) {
        return '/assets/media/integration/cisconetflowcollector.png';
      }
      return '/assets/media/integration/ciscoaci.png';
    }
    if (name.includes('splunk')) {
      if (name.includes('phantom')) {
        return '/assets/media/integration/splunkphantom.png';
      }
      return '/assets/media/integration/splunk.png';
    }
    if (name.includes('snyk')) {
      return '/assets/media/integration/snyk.png';
    }
    if (name.includes('sonarqube')) {
      return '/assets/media/integration/sonarqube.png';
    }
    if (name.includes('veracode')) {
      return '/assets/media/integration/veracodestaticanalysis.png';
    }
    if (name.includes('checkmarx')) {
      return '/assets/media/integration/checkmarxcxsast.png';
    }
    if (name.includes('black duck') || name.includes('blackduck')) {
      return '/assets/media/integration/blackduck.png';
    }
    if (name.includes('carbon black') || name.includes('carbonblack')) {
      return '/assets/media/integration/carbonblack.png';
    }
    if (name.includes('qradar') || (name.includes('ibm') && name.includes('qradar'))) {
      return '/assets/media/integration/ibmqradar.png';
    }
    if (name.includes('maas360')) {
      return '/assets/media/integration/ibmmaas360.png';
    }
    if (name.includes('arcsight')) {
      return '/assets/media/integration/arcsight.png';
    }
    if (name.includes('logrhythm')) {
      return '/assets/media/integration/logrhythm.png';
    }
    if (name.includes('exabeam')) {
      return '/assets/media/integration/exabeam.png';
    }
    if (name.includes('wiz')) {
      return '/assets/media/integration/wizcnapp.png';
    }
    if (name.includes('illumio')) {
      return '/assets/media/integration/illumioadaptivesecurityplatform.png';
    }
    if (name.includes('1password')) {
      return '/assets/media/integration/1password.png';
    }
    if (name.includes('lastpass')) {
      return '/assets/media/integration/lastpass.png';
    }
    if (name.includes('dashlane')) {
      return '/assets/media/integration/dashlane.png';
    }
    if (name.includes('archer')) {
      return '/assets/media/integration/rsaarcher.png';
    }
    if (name.includes('velocloud')) {
      return '/assets/media/integration/velocloud.png';
    }
    if (name.includes('prtg')) {
      return '/assets/media/integration/prtgnetworkmonitor.png';
    }
    if (name.includes('armis')) {
      return '/assets/media/integration/armisassetmanagementandsecurity.png';
    }
    if (name.includes('digicert')) {
      return '/assets/media/integration/digicertpkiplatform.png';
    }
    if (name.includes('entrust')) {
      return '/assets/media/integration/entrustpki.png';
    }
    if (name.includes('globalsign')) {
      return '/assets/media/integration/globalsignpki.png';
    }
    if (name.includes('safenet')) {
      return '/assets/media/integration/safenethsm.png';
    }
    if (name.includes('luna')) {
      return '/assets/media/integration/lunahsm.png';
    }
    if (name.includes('haproxy')) {
      return '/assets/media/integration/haproxy.png';
    }
    if (name.includes('nginx')) {
      return '/assets/media/integration/nginx.png';
    }
    if (name.includes('teamviewer')) {
      return '/assets/media/integration/teamviewer.png';
    }
    if (name.includes('anydesk')) {
      return '/assets/media/integration/anydesk.png';
    }
    if (name.includes('zendesk')) {
      return '/assets/media/integration/zendesk.png';
    }
    if (name.includes('solarwinds')) {
      return '/assets/media/integration/solarwinds.png';
    }
    if (
      name.includes('sentinelone') ||
      name.includes('sentinel one') ||
      name.includes('sentinel-one')
    ) {
      return '/assets/media/integration/sentinelOne.png';
    }
    if (
      name.includes('fortinet') ||
      name.includes('fortigate') ||
      name.includes('forticlient')
    ) {
      return '/assets/media/integration/fortinet.png';
    }
    if (name.includes('manageengine') || name.includes('manage engine')) {
      return '/assets/media/integration/manageEngine.png';
    }
    if (
      name.includes('colortokens') ||
      name.includes('color tokens') ||
      name.includes('color-tokens')
    ) {
      return '/assets/media/integration/color-tokens.png';
    }
    if (name.includes('sophos')) {
      return '/assets/media/integration/sophos.png';
    }
    if (name.includes('qualys')) {
      return '/assets/media/integration/qualys.png';
    }
    if (name.includes('acunetix')) {
      return '/assets/media/integration/acunetix.png';
    }
    if (
      name.includes('microsoft') &&
      (name.includes('entra') || name.includes('azure active directory'))
    ) {
      return '/assets/media/integration/microsoftentra.png';
    }
    if (name.includes('microsoft')) {
      return '/assets/media/integration/microsoft.png';
    }
    if (name.includes('google workspace')) {
      return '/assets/media/integration/google-workspace.png';
    }
    if (
      name.includes('google cloud') ||
      name.includes('gcp') ||
      name.includes('google cloud platform')
    ) {
      return '/assets/media/integration/google-cloud.png';
    }
    if (name.includes('google')) {
      return '/assets/media/integration/google.png';
    }
    if (name.includes('aws') || name.includes('amazon web services')) {
      return '/assets/media/integration/aws.png';
    }
    if (name.includes('quick heal') || name.includes('quickheal')) {
      return '/assets/media/integration/quickheal.png';
    }
    if (name.includes('kaspersky')) {
      return '/assets/media/integration/kaspersky.png';
    }
    if (name.includes('forti')) {
      return '/assets/media/integration/fortinet.png';
    }
    if (name.includes('sumo logic') || name.includes('sumologic')) {
      return '/assets/media/integration/sumologicueba.png';
    }
    if (name.includes('zscaler') || name.includes('zscalar')) {
      return '/assets/media/integration/zscaler.png';
    }
    if (name.includes('crowdstrike')) {
      return '/assets/media/integration/crowdstrike.png';
    }
    if (name.includes('digital guardian') || name.includes('digitalguardian')) {
      return '/assets/media/integration/digitalGuardian.png';
    }
    if (name.includes('recorded future') || name.includes('recordedfuture')) {
      return '/assets/media/integration/recordedFuture.png';
    }
    if (name.includes('palo alto') || name.includes('paloalto')) {
      if (
        name.includes('sase') ||
        name.includes('sd-wan') ||
        name.includes('sdwan')
      ) {
        return '/assets/media/integration/paloaltoprismasdwan.png';
      }
      if (name.includes('xsoar')) {
        return '/assets/media/integration/paloaltoxsoar.png';
      }
      if (name.includes('casb')) {
        return '/assets/media/integration/paloaltonextgencasb.png';
      }
      return '/assets/media/integration/paloaltonetworksglobalprotect.png';
    }

    if (option?.iconUrl && typeof option.iconUrl === 'string' && option.iconUrl.trim()) {
      return option.iconUrl;
    }

    return '/assets/media/integration/default.svg';
  }

  handleImageError(option: any, event: Event) {
    const imgElement = event.target as HTMLImageElement;
    if (imgElement) {
      const fallbackUrl = this.getFallbackIconUrl(option);
      if (!imgElement.src.endsWith(fallbackUrl)) {
        imgElement.src = fallbackUrl;
      } else if (
        !imgElement.src.endsWith('/assets/media/integration/default.svg')
      ) {
        imgElement.src = '/assets/media/integration/default.svg';
      }
    }
  }
}
